<template>
  <vs-card class="w-full collapse-cstm-card">

    <div class="">
      <span style="color: green;">&#10004; = Marked &nbsp; </span>
      <span style="color: red;">&#10008; = Unmarked </span>
    </div>

    <vs-divider />
    
    <div v-if="lessonAssignment.length">
      <vs-collapse v-for="(eachAssignment,index) in lessonAssignment" :key="index">
        <!-- <pre>{{ eachAssignment }}</pre> -->
        <vs-collapse-item>
          <div slot="header">
            <span>{{eachAssignment.title}}</span>

            <div class="marked_unmarked_indicator">
              <div class="indicator" v-if="eachAssignment.sub_total_marks_given > 0">
                <vs-tooltip text="Marked">
                  <span>&#10004;</span>
                </vs-tooltip>
              </div>
              <div v-else>
                <vs-tooltip text="Unmarked">
                  <span>&#10008;</span>
                </vs-tooltip>
              </div>
            </div>

            <div class="each_set_total_marks" v-if="sectionType !== 3">
              <span>
                Total <span class="marks">{{eachAssignment.sub_total_marks}}</span>
              </span>
            </div>
          </div>

          <question-modal
            :QuestionModal="eachAssignment.question_answers"
            Modaltype="assignment"
            :assignment_type_id="sectionType"
            :sectionType="sectionType"
            :platform_customer_id="customer_id"
          ></question-modal>

        </vs-collapse-item>
      </vs-collapse>
    </div>
    <div v-else>
      <h5 class="text-center" style="padding:10px;color:#626262">No content found</h5>
    </div>
  </vs-card>
</template>

<script>
import QuestionModal from './QuestionModal.vue'

export default {
  name: 'grade-assignment-modal',
  components: {
    QuestionModal
  },
  props: {
    lessonAssignment: {
      type: Array,
      required: true,
      default: () => []
    },
    sectionType:{
      type:Number,
      default:null
    }
  },
  data () {
    return {
      customer_id: localStorage.getItem('customer_id')
    }
  },
  created () {
    /* this.lessonAssignment.map((x) => {

      this.$set(x, 'sub_total_marks', 0)
      this.$set(x, 'sub_total_marks_given', 0)

      return x.question_answers
        .map((y) => {
          if (y.answers.user_class_answer_master_id !== undefined) {
            if (y.answers.mark !== null) {
              x.sub_total_marks_given += Number(y.answers.mark)
            }
          }
          x.sub_total_marks += y.questions.point
        })
        .filter(Boolean)
    }) */
  }
}
</script>
<style scoped>
.marked_unmarked_indicator{
    text-align: center;
    width: 30px;
    font-size: 13px;
    float: left;
    padding: 5px 10px;
    margin-right: 50px;
    background-color: rgba(var(--vs-primary), 1);
    border-radius: 5px;
    color: white;
}

.each_set_total_marks{
    font-size: 15px;
    float: right;
    padding: 5px 10px;
    margin-right: 50px;
    background-color: rgba(var(--vs-primary), 1);
    border-radius: 5px;
    color: white;
    box-shadow: 0px 0px 15px #00000026;
}

.each_set_total_marks .marks {
    background: rebeccapurple;
    padding: 3px 5px;
    border-radius: 5px;
    font-size: 12px;
    box-shadow: 0px 0px 1px black;
}
</style>